import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";

const QualityCheckParameterList = (props) => {
  const { addForm, sId } = props;

  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getparameter } = useHttp();
  const getparameterDetail = () => {
    getparameter(
      {
        url: `/api/qualitycheckparameter/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        // //console.log("res:", res);
        if (res) {
          setData(res);
          setAllData(res);
        }
      },
      (error) => {
        console.log("Error", error);
      }
    );
  };

  useEffect(() => {
    getparameterDetail();
  }, [getparameter]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, parameterId) => {
    e.preventDefault();

    const input = {
      parameterId: parameterId,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId:serviceId,
    };

    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Parameter detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/qualitycheckparameter/`,
            method: "DELETE",
            body: input,
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
            }

            if (data.error) {
              //console.log("error:", error);
              toast.error(data.error);
            }
            getparameterDetail();
          },
          (error) => {
            //console.log("Error", error);
            toast.error(error);
            getparameterDetail();
          }
        );
      },
      onCancel() {
        getparameterDetail();
      },
    });
  };
  const handleSearch = (e) => {
   var filtertext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter((item) =>
      item.parameterName.toLowerCase().includes(filtertext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      // height: "80%",
      minHeight: "300px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);
    const Id = data.parameterId;
    getparameter(
      {
        url: `/api/qualitycheckparameter/?orgId=${localStorage.getItem(
          "orgId"
        )}&parameterId=${Id}`,
      },
      (res) => {
        //console.log("detail view res:", res);
        setSelectedData(res);
      },
      (error) => {
        //console.log("Error", error);
      }
    );

    setIsModalOpen(true);
  };
const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);


  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Quality Check Parameter{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2 mx-3"
              onClick={() => {
                addForm(true);
                props.sId(serviceId || 0);
                props.update(false);
              }}
            >
              Add Parameter
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Parameter Name </th>
                            <th>Parameter For </th>
                            <th>View</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.parameterName} </td>
                                <td>{x.parameterFor} </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) =>
                                      handleDelete(e, x.parameterId)
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Quality Check Parameter Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Parameter Name: {selectedData.parameterName}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                parameter For: {selectedData.parameterFor}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">Observation List</p>
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr.No</th>
                    <th>Observation Name</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.observationList &&
                    selectedData.observationList.map((items, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{items.observationName}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default QualityCheckParameterList;
